module.exports = __webpack_public_path__ + "static/media/pinguim.3d66a5e8.png";